export default __webpack_public_path__ + "static/4-3ac434253d71db83d1944c8ec786636e.jpg";